// extracted by mini-css-extract-plugin
export default {"floatLabel":"float-label_floatLabel__jgLXF","label":"float-label_label__AbUYt","labelFloat":"float-label_labelFloat__9zT2Q"};